import AbstractAction from "../AbstractAction.js";

export default class DeleteCustomLabelAction extends AbstractAction {
    constructor(provider, element, label) {
        super(provider);

        this.element = element;
        this.label = label;
        this.index = this.element.labels.labels.findIndex(l => l == this.label);
    }

    finish() {
        this.redo();
        super.finish();
    }

    undo() {
        this.element.labels.labels.splice(this.index, 0, this.label);
        this.updateInfoTab();
    }

    redo() {
        this.element.labels.labels.splice(this.index, 1);
        this.updateInfoTab();
    }

    updateInfoTab() {
        if (this.selection.first == this.element
            && this.selection.length == 1
        ) {
            this.getTab('info').setCurrentElement(this.element);
        }
    }
}
